import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../../components/ui/primitives/Dialog';

interface StudioSettingsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title?: string;
  description?: string;
  children: React.ReactNode;
  onSave?: () => void;
}

export function StudioSettingsDialog({
  open,
  onOpenChange,
  title = 'Ajustes de la actividad',
  description = 'Parámetros globales, metadatos y opciones avanzadas.',
  children,
  onSave,
}: StudioSettingsDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sala-dialog--studio">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <div className="sala-dialog__body">{children}</div>
        <DialogFooter>
          <button type="button" className="sala-btn-outline text-xs" onClick={() => onOpenChange(false)}>
            Cerrar
          </button>
          {onSave && (
            <button
              type="button"
              className="sala-btn-hero text-xs"
              onClick={() => {
                onSave();
                onOpenChange(false);
              }}
            >
              Aplicar
            </button>
          )}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
